export default function (date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
  const d = new Date(date).toLocaleDateString("en-US", options)
  const time = new Date(date).toLocaleString('en-US', { timeZone: 'Asia/Jakarta' }).split(', ')[1]
  return `${d} ${time}`
}